import { Box, Container, Grid } from '@mui/material';
import SectionHeading from '../ui/SectionHeading';
import ModuleCard from '../ui/ModuleCard';
import Reveal from '../ui/Reveal';
import { modules } from '../../data/modules';

const ModulesSection = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.paper' }}>
      <Container>
        <SectionHeading
          overline="Modular by design"
          title="Pick the modules your ISP actually needs"
          subtitle="Choose your internet engine, add the services you run, then bolt on fiscalization, OLT management and online payments. No setup fees."
        />
        <Grid container spacing={3.5}>
          {modules.map((m, i) => (
            <Grid item xs={12} sm={6} md={4} key={m.id}>
              <Reveal delay={i * 60} sx={{ height: '100%' }}>
                <ModuleCard module={m} />
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ModulesSection;
